export default __webpack_public_path__ + "zoom-out.png";